// extracted by mini-css-extract-plugin
module.exports = {"loading":"Timeline_loading__3Do57","timelineName":"Timeline_timelineName__2RoIB"};